import React from "react";

const DeleteProductModal  = ({ product, onDelete, onClose }) => {
  return (
    <div className="rounded-md shadow dark:shadow-gray-800 bg-slate-900/75 text-slate-900 dark:text-white fixed w-full h-screen top-0 left-0 bottom-0 right-0 flex items-center justify-center z-999">
      <div className="relative w-full h-auto max-w-md inline-block bg-white dark:bg-slate-900">
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 dark:border-gray-700">
          <h3 className="font-bold text-lg">Confirm Product Deletion</h3>
        </div>
        <div className="p-6">
          <p className="text-gray-600">
            Are you sure you want to delete <strong>{product?.title}</strong>?
          </p>
          <div className="mt-4 flex flex-row justify-evenly">
            <button className="py-2 px-5 w-24 font-semibold tracking-wide align-middle duration-500 text-base text-center text-slate-900 rounded-md border-gray-700 border justify-center flex items-center"
            onClick={onClose}>
              Cancel
            </button>
            <button className="py-2 px-5 w-24 font-semibold tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md justify-center flex items-center"
            onClick={() => onDelete(product?.id)}>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteProductModal;
